<template>
  <div>
    <b-input
      v-model="audit.name"
      :error-messages="getErrorMessages(v$.name)"
      label="Назва"
      placeholder="Введіть назву"
      @blur="v$.name.$touch()"></b-input>

    <v-row>
      <v-col cols="6">
        <b-select
          v-model="audit.typeId"
          :disabled="dialog.action === 'update' || !!dialog.dialogData.plan"
          :error-messages="getErrorMessages(v$.typeId)"
          :items="$directory.get('auditTypes', dialog.dialogData.audit?.type)"
          :loading="$loading.isLoading('auditTypes')"
          label="Тип"
          @blur="v$.typeId.$touch()"></b-select>
      </v-col>
      <v-col cols="6">
        <b-select
          v-if="audit.typeId === 2"
          v-model="audit.year"
          :error-messages="getErrorMessages(v$.year)"
          :items="yearOptions"
          label="Рік"
          placeholder="Оберіть рік"
          @blur="v$.year.$touch()"></b-select>

        <div v-else>
          <b-input
            v-if="dialog.dialogData.plan"
            :model-value="`${dialog.dialogData.plan.year} - ${dialog.dialogData.plan.name}`"
            disabled
            label="План"></b-input>

          <b-server-autocomplete
            v-show="audit.typeId === 1 && !dialog.dialogData.plan"
            v-model="plan"
            :error-messages="getErrorMessages(v$.planId)"
            :item-title="(p: any) => `${p.year} - ${p.name}`"
            label="План"
            placeholder="Введіть назву плану"
            return-object
            url="/json/auditPlan"
            @blur="v$.planId.$touch()"></b-server-autocomplete>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { PropType, reactive, ref, watch } from 'vue'
import { Dialog } from '@/dialog'
import { required, requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getErrorMessages } from 'best-modules/utils'
import { Audit } from '@/utils/types/audit'
import { fillDirectory } from '@/directory'
import { BServerAutocomplete } from 'best-modules/components'
import { auditCreate, auditUpdate } from '@/requests/audit'
import { planList as planListRequest } from '@/requests/plan'

export default {
  name: 'Audit',
  components: { BServerAutocomplete },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages, planListRequest },
  setup(props) {
    const audit = reactive<Audit>({
      typeId: 1,
      name: null,
      year: props.dialog.dialogData.plan?.year
        ? String(props.dialog.dialogData.plan.year)
        : null,
      planId: props.dialog.dialogData.plan?.id || null,
    } as Audit)
    const plan = ref()
    if (props.dialog.action === 'update') {
      Object.assign(audit, props.dialog.dialogData.audit)
    } else {
      fillDirectory('auditTypes')
    }

    const currentYear = new Date().getFullYear()

    const yearOptions = [
      String(currentYear - 1),
      String(currentYear),
      String(currentYear + 1),
    ]

    const rules = {
      name: { required: required },
      year: { required: required },
      typeId: { required: required },
      planId: { required: requiredIf(() => audit.typeId === 1) },
    }
    const v$ = useVuelidate(rules, audit)

    const submit = () => {
      const request =
        props.dialog.action === 'create'
          ? auditCreate(audit)
          : auditUpdate(audit.id, audit)

      return request.then(res => res)
    }

    watch(
      () => audit.typeId,
      t => {
        v$.value.year.$reset()
        v$.value.planId.$reset()
        audit.year = null as any
        if (t === 2) {
          plan.value = null
        }
      }
    )

    watch(plan, p => {
      if (p) {
        audit.planId = p.id
        audit.year = p.year
      } else {
        audit.planId = null as any
      }
    })

    return { audit, plan, v$, submit, yearOptions }
  },
}
</script>

<style lang="scss" scoped></style>
